import { KeyValueParamSerializer } from "@app-contexts/public/features/key-value-params/data/services/useKeyValueService";
import keyBy from "lodash/keyBy";
import {
  parseFromLocalStorage,
  set,
} from "@shared/utils/storage/cache-storage";

export enum ABTestResult {
  CONTROL = "control",
  EXPERIMENT = "experiment",
}

type LocalStorageType = { $value: ABTestResult };

export const computeABTest = (
  name: string,
  data: KeyValueParamSerializer[],
  venueId?: number
) => {
  const keyValueParamsLookup = keyBy(data, "key");
  const storedResult = parseFromLocalStorage<LocalStorageType>(
    `ab_test_${name}`
  )?.$value;
  const neverAllowed =
    venueId &&
    keyValueParamsLookup?.[`${name}_disallowed_venue_ids`]?.value?.includes(
      venueId.toString()
    );
  const alwaysAllowed =
    venueId &&
    keyValueParamsLookup?.[`${name}_allowed_venue_ids`]?.value?.includes(
      venueId.toString()
    );
  // if there is no split percentage then fallback to no impedance
  const value = keyValueParamsLookup?.[`${name}_split_percentage`]?.value;
  const splitPercentage = value != null ? parseInt(value, 10) : 100;

  if (alwaysAllowed) {
    return ABTestResult.EXPERIMENT;
  }

  if (neverAllowed) {
    return ABTestResult.CONTROL;
  }

  if (storedResult) {
    return storedResult;
  }

  const result =
    Math.random() <= splitPercentage / 100
      ? ABTestResult.EXPERIMENT
      : ABTestResult.CONTROL;

  set(`ab_test_${name}`, result, null);
  return result;
};
